import { FormControl, InputLabel, MenuItem, Select, SelectProps } from '@mui/material';
import React from 'react';

import { CrisRequestType } from '../constants/cris-request-type';

type PatternTypeSelectorProps = SelectProps & {
    value: CrisRequestType;
};

export class PatternTypeSelector extends React.Component<PatternTypeSelectorProps> {
    public render(): React.ReactNode {
        return (
            <FormControl variant='outlined' className='my-2' style={{ minWidth: '12em' }} size='small'>
                <InputLabel id='request-type-label'>Pattern Type</InputLabel>
                <Select name='type' label='Pattern Type' {...this.props} labelId='request-type-label'>
                    <MenuItem value={CrisRequestType.STORE}>Store</MenuItem>
                    <MenuItem value={CrisRequestType.CHANNEL}>Channel</MenuItem>
                    <MenuItem value={CrisRequestType.LOCATION}>Store Number</MenuItem>
                </Select>
            </FormControl>
        );
    }
}
